// 配置文件
import { currentDev } from "./env";
// 🔴 2026-09-08 换域名改造（D8-c 拆炸弹 + 档位 1 指向考拉正式域名）
//   原写法：档 2 是 `location.hostname.match(/[a-zA-Z]+/) ? 硬编码 : location.origin`。
//   现在 hostname 是纯数字 IP 所以走 location.origin（同源）看着没问题，
//   但**域名一上线 hostname 有了字母，就会翻转到硬编码那一侧** —— 这是定时炸弹，
//   已按 D8-c 的要求「删掉 location.hostname.match 这个条件本身」。
//   环境靠 index.html 里的 GLOBAL_ENV 区分：test→档2、pre→档3、其它/未定义→档1。
//
// 🔴 2026-09-20 改回同源相对路径。上面那次改造把档位定成了**另一个子域的绝对地址**，
//   于是 axios 的 baseURL 跨了域（mass.kolaanmo.com → api.kolaanmo.com），
//   而 api 那边没有任何 CORS：CDP 在页面上下文实测 `corsError=MissingAllowOriginHeader`，
//   网关两份 Caddyfile 和 wy-spa 的 Java、yml 里都搜不到一条 Access-Control-*。
//   本站的 Caddy 段（`mass.kolaanmo.com, :4432` 与 masstest 同构）本来就带着
//   `handle /api/* → 127.0.0.1:8093`，和 vite.config.ts 的 proxy 前缀一一对应 ——
//   同源反代才是既定架构（旧写法里 `location.origin` 那一侧就是它），
//   兄弟应用 train-h5-tech 也一直用同站相对路径请求 /tech-course/api/*。
//   走同源还顺带满足铁律「正式服只引用正式服」：地址跟着当前域名走，
//   正式站不可能再打到测试后端，也不用为此扩大 CORS 的放行面。
//   三档同值是有意为之：环境已由域名本身决定，不再需要档位参与。
//   `pnpm dev` 下相对路径命中 vite.config.ts 的 `/api` proxy，本地调试不受影响。
const urlLink = {
  1: "/", //正式 mass.kolaanmo.com → 同站 Caddy handle /api/* → wy-spa:8093
  2: "/", //内测 masstest.kolaanmo.com → 同上（该站段与正式同构）
  3: "/", //预发布
};

// 🔴 2026-09-20 同上，gRPC-Web 也改回同源。它比 HTTP 那条更硬伤：
//   bt-rpc-web 的 ServiceConfig 带 `withCredentials: true`，跨域预检要求更严，
//   CDP 在页面上下文实测 `corsError=PreflightMissingAllowOriginHeader`
//   （OPTIONS 预检就没过，GET/POST 压根发不出去）→ **技师端登录直接不可用**，
//   登录走的 /tech/MobileAuth/* 正是这条链。
//   本站 Caddy 段里 `/tech/* /wy/* /discuss/* /partner/*` 四条都反代到 127.0.0.1:50065
//   （Envoy 做 gRPC-Web → gRPC 转换），同源链路本来就是通的。
//   这里用 `location.origin + "/"` 而不是像 urlLink 那样用 "/"：
//   bt-rpc-web 是私有包、不在 node_modules 里，无法静态确认它对相对路径的处理，
//   给绝对同源 URL 最稳妥，且与用户端 wangyue_h5_user 档 2 的 `location.origin` 同一写法。
const tsApiOrigin = location.origin + "/";
const tsApiLink = {
  1: tsApiOrigin, //正式 mass.kolaanmo.com → 同站 Caddy handle /tech|/wy|/discuss|/partner → Envoy:50065
  2: tsApiOrigin, //内测 masstest.kolaanmo.com → 同上
  3: tsApiOrigin, //预发布
};

// 🔴 jieyue.com 是「今往」（考拉关联公司）的管理端，**考拉没有这块业务**，
//   三档一律黑洞化。原值留在注释里备查：
//     1: https://imgr.jieyue.com/  2: https://imgrtest.jieyue.com/  3: https://imgrpre.jieyue.com/
//   其中档 2 原本还带 hostname 条件，域名上线会翻转成直连考拉域名（出网禁止清单）——
//   这正是 D8-c 点名的那一处。
const jyMgrApiLink = {
  1: "http://127.0.0.1:9/",
  2: "http://127.0.0.1:9/",
  3: "http://127.0.0.1:9/",
}

const wyh5AppLink = {
  1: 'https://mass.kolaanmo.com/#', //生产（h5-tech 自己，经边缘网关 → 4432）
  2: 'https://masstest.kolaanmo.com/#', //测试
  3: 'https://mass.kolaanmo.com/pre/#', //预发布
}

const wyUserh5AppLink = {
  1: 'https://h.kolaanmo.com/#', //生产（h5-user，经边缘网关 → 4430）。原为黑洞 127.0.0.1:9
  2: `${import.meta.env.DEV ? "https://localhost:4430/#" : 'https://htest.kolaanmo.com/#'}`, //测试
  3: 'https://h.kolaanmo.com/pre/#', //预发布
}

// ⚠️ 档 2 原本是 https://traintest.wangyuedaojia.com/train.html#（**考拉域名，出网禁止清单**），
//   而且它**没有 hostname 条件保护**，是无条件生效的 —— D8-c 首轮扫描没记到这一条。
const collegeDomain = {
  1: "https://mass.kolaanmo.com/train.html#", //正式（train.html 与 h5-tech 同站，4432）
  2: "https://masstest.kolaanmo.com/train.html#", //内测（改自考拉域名）
  3: "https://mass.kolaanmo.com/pre/train.html#", //预发布
}

const isWYHost = !!location.hostname.match('kolaanmo')   // 旧域名兜底匹配：原 'wangyuedaojia'，考拉域名下恒为 false 会走 location.origin 分支
const regTel = /^1[3456789]\d{9}$/ //手机号校验
const regCode = /(\d){6}$/ //验证码校验
const baseUrl = urlLink[currentDev];
const tsApiBaseUrl = tsApiLink[currentDev];
const jyMgrApiBaseUrl = jyMgrApiLink[currentDev];
const h5Url = isWYHost ? wyh5AppLink[currentDev] : `${location.origin}${location.pathname}#`;
const wyUserUrl = wyUserh5AppLink[currentDev]
const collegeDomainUrl = collegeDomain[currentDev];
export { regTel, baseUrl, tsApiBaseUrl, jyMgrApiBaseUrl, h5Url, wyUserUrl, regCode, collegeDomainUrl };